import type { ZodError } from "zod";

export function extractFieldErrors(zodError: ZodError): Record<string, string> {
  const fieldErrors: Record<string, string> = {};
  for (const issue of zodError.issues) {
    const field = issue.path[0];
    if (typeof field === "string") {
      fieldErrors[field] = issue.message;
    }
  }
  return fieldErrors;
}

export async function parseFormData(request: Request): Promise<Record<string, string>> {
  const formData = await request.formData();
  const data: Record<string, string> = {};
  for (const [key, value] of formData.entries()) {
    if (typeof value === "string") {
      data[key] = value;
    }
  }
  return data;
}
